import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=b41504a6&scoped=true&"
import script from "./Assignments.vue?vue&type=script&lang=js&"
export * from "./Assignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41504a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41504a6')) {
      api.createRecord('b41504a6', component.options)
    } else {
      api.reload('b41504a6', component.options)
    }
    module.hot.accept("./Assignments.vue?vue&type=template&id=b41504a6&scoped=true&", function () {
      api.rerender('b41504a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AssignationMultiple/Assignments.vue"
export default component.exports